import { useCallback, useState } from "react";
import { getTemplateFile } from "../../network";

export const useGetTemplateFile = (): [
  boolean,
  Error | null,
  (template_id: string) => Promise<void>
] => {
  const [isLoading, setIsLoading] = useState<boolean>(false);
  const [error, setError] = useState<Error | null>(null);

  const request = useCallback(async (template_id: string) => {
    setIsLoading(true);
    setError(null);
    try {
      const response = await getTemplateFile(template_id);
      
      const link = document.createElement("a");
      link.href = response.url;
      link.download = "";
      document.body.appendChild(link);
      link.click();
      document.body.removeChild(link);
    } catch (e) {
      if (e instanceof Error) {
        setError(e);
      } else {
        setError(new Error("Unknown error"));
      }
      throw e;
    } finally {
      setIsLoading(false);
    }
  }, []);

  return [isLoading, error, request];
};

